import React, { createContext, useCallback, useContext, useState } from "react";

import { Subcontractor } from "../../../../../../../../models/subcontractor";

type SubcontractorKeys = "all" | keyof Subcontractor;

interface SubcontractorContextProps {
  subcontractor: Subcontractor;
  setSubcontractor: React.Dispatch<React.SetStateAction<Subcontractor>>;
  onUpdateSubcontractor: (attribute: SubcontractorKeys, value: any) => void;
}

const SubcontractorContext = createContext<SubcontractorContextProps>(
  {} as SubcontractorContextProps
);

const SubcontractorProvider: React.FC = ({ children }) => {
  const [subcontractor, setSubcontractor] = useState<Subcontractor>({} as Subcontractor);

  const onUpdateSubcontractor = useCallback((attribute: SubcontractorKeys, value: any) => {
    if (attribute && attribute !== "all") {
      if (!["string", "number", "boolean", "object"].includes(typeof value))
        setSubcontractor((state) => ({ ...state, [attribute]: [...value] }));
      else setSubcontractor((state) => ({ ...state, [attribute]: value }));
    } else {
      setSubcontractor({ ...value });
    }
  }, []);

  return (
    <SubcontractorContext.Provider
      value={{
        subcontractor,
        setSubcontractor,
        onUpdateSubcontractor,
      }}
    >
      {children}
    </SubcontractorContext.Provider>
  );
};

const useSubcontractorContext = () => {
  const context = useContext(SubcontractorContext);

  return context;
};

export { SubcontractorProvider, useSubcontractorContext };
